import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Globales } from '../../../Global';

@Component({
  selector: 'app-menu-link',
  templateUrl: './menu-link.component.html',
  styleUrls: ['./menu-link.component.css']
})
export class MenuLinkComponent implements OnInit {
  @Input() sections;
  name: string;
  data: any;

  constructor(private router: Router, public dialog: MatDialog,
    public globals: Globales) { }

  ngOnInit() {
    if (this.sections.hijos.length > 0) {
      this.data = this.sections.hijos.sort((a, b) => { return a.orden - b.orden });
    }
  }

  VerMenu(evento: string) {
    this.router.navigate(['/home/' + evento]);
  }

}
